import { MuiFileInput } from "mui-file-input"
import { FieldArray, Field, getIn, useFormikContext } from "formik"
import { Link, Button, Grid2 as Grid, Stack, Divider, IconButton } from "@mui/material"
import { Allegato, Resposabile } from "../../types"
import { FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"
import { Add, Delete, Edit } from "@mui/icons-material"
import { ACPersona, ACVocabolario } from "./autocompletes"
import PersonaForm from "./PersonaForm"
import { usePersonaCreate } from "../../hooks/persone"

type FormikFileInputProps = {
  field: {
    name: string
    value: File | null
  }
  form: {
    setFieldValue: (field: string, value: File | null) => void
    setFieldTouched: (field: string, isTouched: boolean) => void
    errors: Record<string, any>
  }
  originalName?: string
  errorName: string
}

function FormikFileInput({ field, form, originalName, errorName, ...props }: FormikFileInputProps) {
  const { setFieldValue, setFieldTouched, errors } = form

  const { name, value } = field
  const isUrl = typeof value === "string"
  const error = getIn(errors, errorName)

  return isUrl ? (
    <Stack direction="row" alignItems={"center"} sx={{ mt: 2 }}>
      <Link href={value} noWrap>
        {originalName}
      </Link>
      <IconButton
        color="primary"
        size="small"
        sx={{ ml: 2 }}
        onClick={() => {
          setFieldValue(name, null)
        }}
      >
        <Edit />
      </IconButton>
    </Stack>
  ) : (
    <MuiFileInput
      error={!!error}
      fullWidth
      margin="dense"
      helperText={error}
      variant="outlined"
      value={value ?? null}
      onChange={(file: File | null) => {
        setFieldValue(name, file)
      }}
      onBlur={() => {
        setFieldTouched(name, true)
      }}
      {...props}
    />
  )
}

export function AllegatiField({ values, name }: { values: { allegati_data: Allegato[] }; name: string }) {
  const { t } = useTranslation()

  return (
    <FieldArray name={name}>
      {({ remove, push }) => (
        <div>
          {values.allegati_data &&
            values.allegati_data.length > 0 &&
            values.allegati_data.map((allegato: Allegato, index: number) => (
              <>
                <Stack key={index} direction="row" spacing={2} alignItems="start" sx={{ my: 2 }}>
                  <Grid container spacing={2} flexGrow={1}>
                    <Grid size={6}>
                      <Field
                        variant="outlined"
                        margin="dense"
                        size="small"
                        label="File"
                        placeholder={t("general.scegli_file")}
                        component={FormikFileInput}
                        name={`allegati_data[${index}].attachment`}
                        errorName={`allegati[${index}].attachment`}
                        originalName={allegato.nome_originale}
                      />
                      {/* <Field name={`friends.${index}.name`} placeholder="Jane Doe" type="text" />
                <ErrorMessage name={`friends.${index}.name`} component="div" className="field-error" /> */}
                    </Grid>
                    <Grid size={5}>
                      <Field
                        label="note"
                        name={`allegati_data.[${index}].note`}
                        placeholder="Note"
                        component={FormikTextField}
                        margin="dense"
                        fullWidth
                        size="small"
                        multiline
                        minRows={6}
                      />
                      {/* <Field name={`friends.${index}.email`} placeholder="jane@acme.com" type="email" />
                <ErrorMessage name={`friends.${index}.name`} component="div" className="field-error" /> */}
                    </Grid>
                    <Grid size={1}>
                      <IconButton
                        title="Elimina allegato"
                        sx={{ mt: 1 }}
                        color="error"
                        type="button"
                        onClick={() => {
                          remove(index)
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Stack>
                <Divider></Divider>
              </>
            ))}

          <Button variant="contained" type="button" onClick={() => push({ note: "" })} sx={{ mt: 2 }}>
            <Add sx={{ mr: 1 }} />
            {t("general.aggiungi_allegato")}
          </Button>
        </div>
      )}
    </FieldArray>
  )
}

export function AllegatiImmagineField({
  values,
  name,
}: {
  values: { allegati_immagine_data: Allegato[] }
  name: string
}) {
  const { t } = useTranslation()

  return (
    <FieldArray name={name}>
      {({ remove, push }) => (
        <div>
          {values.allegati_immagine_data &&
            values.allegati_immagine_data.length > 0 &&
            values.allegati_immagine_data.map((allegato: Allegato, index: number) => (
              <>
                <Stack key={index} direction="row" spacing={2} alignItems="start" sx={{ my: 2 }}>
                  <Grid container spacing={2} flexGrow={1}>
                    <Grid size={6}>
                      <Field
                        variant="outlined"
                        margin="dense"
                        size="small"
                        label="File"
                        placeholder={t("general.scegli_file")}
                        component={FormikFileInput}
                        name={`allegati_immagine_data[${index}].attachment`}
                        errorName={`allegati_immagine[${index}].attachment`}
                        originalName={allegato.nome_originale}
                      />
                      {/* <Field name={`friends.${index}.name`} placeholder="Jane Doe" type="text" />
                <ErrorMessage name={`friends.${index}.name`} component="div" className="field-error" /> */}
                    </Grid>
                    <Grid size={5}>
                      <Field
                        label="note"
                        name={`allegati_immagine_data.[${index}].note`}
                        placeholder="Note"
                        component={FormikTextField}
                        margin="dense"
                        fullWidth
                        size="small"
                        multiline
                        minRows={6}
                      />
                      {/* <Field name={`friends.${index}.email`} placeholder="jane@acme.com" type="email" />
                <ErrorMessage name={`friends.${index}.name`} component="div" className="field-error" /> */}
                    </Grid>
                    <Grid size={1}>
                      <IconButton
                        title="Elimina allegato"
                        sx={{ mt: 1 }}
                        color="error"
                        type="button"
                        onClick={() => {
                          remove(index)
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Stack>
                <Divider></Divider>
              </>
            ))}

          <Button variant="contained" type="button" onClick={() => push({ note: "" })} sx={{ mt: 2 }}>
            <Add sx={{ mr: 1 }} />
            {t("general.aggiungi_allegato_immagine")}
          </Button>
        </div>
      )}
    </FieldArray>
  )
}

export function ResponsabiliField({
  values,
  name,
  errors,
}: {
  values: { responsabili_data: Resposabile[] }
  name: string
  errors: Record<string, any>
}) {
  const { t } = useTranslation()
  console.log("ee", errors, getIn(errors, `responsabili_data[0].persona`))
  const { setFieldValue } = useFormikContext()

  const {mutateAsync: createPersona} = usePersonaCreate()

  return (
    <FieldArray name={name}>
      {({ remove, push }) => (
        <div>
          {values.responsabili_data &&
            values.responsabili_data.length > 0 &&
            values.responsabili_data.map((_responsabile: Resposabile, index: number) => (
              <>
                <Stack key={index} direction="row" spacing={2} alignItems="start" sx={{ my: 2 }}>
                  <Grid container spacing={2} flexGrow={1}>
                    <Grid size={3}>
                      <ACPersona
                        label="persona"
                        value={values.responsabili_data[index].persona}
                        onChange={(value: any) => {
                          setFieldValue(`responsabili_data[${index}].persona`, value)
                        }}
                        margin="dense"
                        fullWidth
                        size="small"
                        error={getIn(errors, `responsabili_data[${index}].persona`)}

                        FormComponent={PersonaForm}
                        create={createPersona}
                        initialCreate={(search) => ({ nome: search })}


                        
                      />
                    </Grid>

                    <Grid size={3}>
                      <ACVocabolario
                        label="ruolo"
                        value={values.responsabili_data[index].ruolo}
                        onChange={(value: any) => {
                          setFieldValue(`responsabili_data[${index}].ruolo`, value)
                        }}
                        margin="dense"
                        fullWidth
                        size="small"
                        error={getIn(errors, `responsabili_data[${index}].ruolo`)}
                        vocabolario="ruolo"
                      />
                    </Grid>

                    <Grid size={5}>
                      <Field
                        label="note"
                        name={`responsabili_data.[${index}].note`}
                        placeholder="Note"
                        component={FormikTextField}
                        margin="dense"
                        fullWidth
                        size="small"
                        multiline
                        minRows={6}
                      />
                    </Grid>

                    <Grid size={1}>
                      <IconButton
                        title="Elimina responsabile"
                        sx={{ mt: 1 }}
                        color="error"
                        type="button"
                        onClick={() => {
                          remove(index)
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Stack>
                <Divider></Divider>
              </>
            ))}

          <Button variant="contained" type="button" onClick={() => push({ note: "" })} sx={{ mt: 2 }}>
            <Add sx={{ mr: 1 }} />
            {t("general.aggiungi_responsabile")}
          </Button>
        </div>
      )}
    </FieldArray>
  )
}
